import {
  GET_LAWS,
  SET_LAWS,
  GET_LAWS_ERROR,
  RESET_LAWS,
  SET_LAW_FILTERS,
  RESET_LAW_FILTERS
} from './types'
import { RESET_TOKEN, SET_ACTIVE_WORKSPACE } from 'utils/auth/types'

const initialLawFilters = {
  countries: []
}

const initialState = {
  laws: [],
  lawsNext: null,
  isLoadingLaws: false,
  lawFilters: initialLawFilters,
  filtersWorkspaceId: null
}

const lawsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAWS:
      return {
        ...state,
        isLoadingLaws: true
      }
    case SET_LAWS:
      return {
        ...state,
        laws: action.payload.laws,
        lawsNext: action.payload.lawsNext,
        isLoadingLaws: false
      }
    case GET_LAWS_ERROR:
      return {
        ...state,
        isLoadingLaws: false
      }
    case RESET_LAWS:
      return {
        ...state,
        laws: [],
        isLoadingLaws: false
      }
    case SET_LAW_FILTERS:
      return {
        ...state,
        lawFilters: {
          ...state.lawFilters,
          ...action.payload.filters
        }
      }
    case RESET_LAW_FILTERS:
      return {
        ...state,
        lawFilters: initialLawFilters
      }
    case SET_ACTIVE_WORKSPACE: {
      const workspaceId = action.payload.activeWorkspace.id
      if (workspaceId === state.filtersWorkspaceId) {
        return state
      }
      return {
        ...state,
        lawFilters: initialLawFilters,
        filtersWorkspaceId: workspaceId
      }
    }
    case RESET_TOKEN:
      return {
        ...state,
        lawFilters: initialLawFilters,
        filtersWorkspaceId: null
      }
    default:
      return state
  }
}

export default lawsReducer
